// main.js
import "./style.scss";
import Experience from "./scripts/Experience";
import { validateParams } from "./scripts/Utils/utils";

const urlParams = new URLSearchParams(window.location.search);
const { params, missingParams } = validateParams(urlParams);

const isLocalhost = location.hostname === "localhost";
const isStaging = location.hostname.startsWith("stage.");

if (!isLocalhost && !isStaging) {
  // clear the params from the url to look cleaner
  window.history.replaceState({}, document.title, window.location.pathname);
}

// Create the experience instance
const experience = new Experience(params, missingParams);

// Expose the instance for debugging
// TODO - remove this line in production
window.experience = experience;
